'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Metadata = undefined;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _verify = require('helpers/verify');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable react/no-unused-prop-types */
var renderLink = function renderLink(rel, href) {
  return !(0, _verify.isBlank)(href) && _react2.default.createElement('link', { rel: rel, href: href });
};
var renderMeta = function renderMeta(metaName, content) {
  return !(0, _verify.isBlank)(content) && _react2.default.createElement('meta', { name: metaName, content: content });
};
var renderOpenGraph = function renderOpenGraph(metaName, content) {
  return !(0, _verify.isBlank)(content) && _react2.default.createElement('meta', { property: metaName, content: content });
};
var renderTitle = function renderTitle(content) {
  return !(0, _verify.isBlank)(content) && _react2.default.createElement(
    'title',
    null,
    content
  );
};

var Metadata = exports.Metadata = function Metadata() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      canonicalUrl = _ref.canonicalUrl,
      description = _ref.description,
      _ref$shouldIndex = _ref.shouldIndex,
      shouldIndex = _ref$shouldIndex === undefined ? true : _ref$shouldIndex,
      ogDescription = _ref.ogDescription,
      ogImage = _ref.ogImage,
      ogTitle = _ref.ogTitle,
      ogUrl = _ref.ogUrl,
      title = _ref.title;

  return _react2.default.createElement(
    _reactHelmet2.default,
    null,
    renderTitle(title),
    renderMeta('description', description),
    renderOpenGraph('og:title', ogTitle || title),
    renderOpenGraph('og:description', ogDescription || description),
    renderOpenGraph('og:image', ogImage),
    renderOpenGraph('og:url', ogUrl),
    renderMeta('robots', shouldIndex ? 'index' : 'noindex'),
    renderLink('canonical', canonicalUrl)
  );
};

Metadata.propTypes = {
  description: _propTypes2.default.string,
  shouldIndex: _propTypes2.default.bool,
  ogDescription: _propTypes2.default.string,
  ogImage: _propTypes2.default.string,
  ogTitle: _propTypes2.default.string,
  ogUrl: _propTypes2.default.string,
  title: _propTypes2.default.string.isRequired
};